<div style="padding: 8px; max-height: calc(100vh - 140px); box-sizing: border-box;">
    <div class="line2">
        {{pageTitle}}
        <div class="action">
            @if(mode==="read" && !this.isNew){
            <ppl-button [label]="'Back'" icon="fa fa-chevron-left" (click)="goBack()"
                [customClass]="'primary-button semi-rounded'" [iconPosition]="'left'"></ppl-button>
            }
        </div>
    </div>
    <div style="width: 100%">
        <ppl-accordion [title]="'Lookup Information'" [isOpen]="true">
            <div class="wiz-body">
                <div class="ppl-mt24" style="width: 100%">
                    <div class="custom-row">
                        @if(mode==="read" && !this.isNew){
                        <ppl-button label="Edit" icon="fa fa-pencil" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="onEdit()" style="margin-right: 8px;"></ppl-button>
                        <ppl-button label="Delete" icon="fa fa-trash" [customClass]="'ghost-button'"
                            [iconPosition]="'left'" (click)="onDelete()"></ppl-button>
                        }
                    </div>
                    @if(mode==="edit"){
                    <form nz-form nz-row [formGroup]="configForm" class="ppl-p0">
                        @if(isAttrAvailable('lkpDomainName')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpDomainName"
                                    class="ppl-form-label">{{getAttributes('lkpDomainName').label}}
                                    @if(getAttributes('lkpDomainName').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpDomainName')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <input nz-input formControlName="lkpDomainName" id="lkpDomainName"
                                            placeholder="{{getAttributes('lkpDomainName').placeholder}}"
                                            [ngClass]="{'error': validationErrors['lkpDomainName'] }" />
                                    </div>
                                    @if (validationErrors['lkpDomainName']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpDomainName']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }

                        @if(isAttrAvailable('lkpDomainDesc')){
                        <nz-form-item nz-col nzSpan="12" class="ppl-form-item nz-padding-left">
                            <nz-row>
                                <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="lkpDomainDesc"
                                    class="ppl-form-label">{{getAttributes('lkpDomainDesc').label}}
                                    @if(getAttributes('lkpDomainDesc').mandatory === 'Y'){
                                    <span [attr.aria-label]="'Required'">*</span>
                                    }
                                </nz-form-label>
                                <nz-form-control [nzSm]="12" [nzXs]="24" class="ppl-form-control">
                                    <div nz-tooltip [nzTooltipTitle]="getAttributes('lkpDomainDesc')?.tooltip || ''"
                                        nzTooltipPlacement="topRight">
                                        <input nz-input formControlName="lkpDomainDesc" id="lkpDomainDesc"
                                            placeholder="{{getAttributes('lkpDomainDesc').placeholder}}"
                                            [ngClass]="{'error': validationErrors['lkpDomainDesc'] }" />
                                    </div>
                                    @if (validationErrors['lkpDomainDesc']) {
                                    <span class="pl-1 error-message">{{validationErrors['lkpDomainDesc']}}</span>
                                    }
                                </nz-form-control>
                            </nz-row>
                        </nz-form-item>
                        }
                    </form>
                    @if(isNew){
                    <div class="custom-row">
                        <ppl-button [label]="'Cancel'" [icon]="'fa fa-close'"
                            style="margin-right:4px; font-size:0.857rem;" [customClass]="'ghost-button'"
                            [iconPosition]="'right'" (click)="goBack()"></ppl-button>
                        <ppl-button label="Submit" icon="fa fa-check-circle" [customClass]="'primary-button'"
                            [iconPosition]="'right'" (click)="onAdd('add')"></ppl-button>
                    </div>
                    }
                    }
                    @else if (mode==="read") {
                    <div nz-row>
                        @if(isAttrAvailable('lkpDomainName')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpDomainName").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpDomainName }}</div>
                            </div>
                        </div>
                        }
                        @if(isAttrAvailable('lkpDomainDesc')){
                        <div nz-col nzSpan="12">
                            <div nz-row>
                                <div nz-col nzSpan="8" ngClass="font-weight-600 pt-2 pb-2">
                                    {{ getAttributes("lkpDomainDesc").label }}
                                </div>
                                <div nz-col nzSpan="16" ngClass="pt-2 pb-2">{{ savedData?.lkpDomainDesc }}</div>
                            </div>
                        </div>
                        }
                    </div>
                    }
                    <div class="custom-row">
                        @if(mode==="edit" && !this.isNew){
                        <ppl-button label="Cancel" icon="fa fa-ban" [customClass]="'alt-button'" [iconPosition]="'left'"
                            (click)="onCancel()"></ppl-button>
                        <ppl-button label="Save" icon="fa fa-floppy-o" [customClass]="'alt-button'"
                            [iconPosition]="'left'" (click)="onAdd('update')"></ppl-button>
                        }
                    </div>
                </div>
            </div>
        </ppl-accordion>
    </div>
</div>

<div class="filter-panel">
    <ng-template #confirmationDialog let-cancel="cancel">
        <p> Are you sure you want to delete this config ?</p>
    </ng-template>
</div>